module.exports = ".app-sidebar {\n  position: relative;\n  height: 100%; }\n\n::ng-deep .sidebar-mobile-open .app-sidebar {\n  margin-right: 1rem; }\n\n@media (max-width: 767px) {\n  .app-sidebar {\n    left: 0;\n    top: 60px;\n    position: fixed; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidenav/sidenav.component.scss
// module id = 908
// module chunks = 10